<li class="list-item">
  <h3 class="line-break">{{join}} <i>{{label}}</i> {{operator}} <i>{{oldValue}}</i></h3>
</li>
